import { useTranslation } from "react-i18next";
import { Eye, EyeOff, StickyNote } from "lucide-react";
import clsx from "clsx";
import { Button } from "components/common/Button";
import type { MarkerNotesControlProps } from "./types";

export const MarkerNotesControl = ({
  count,
  areNotesVisible,
  onToggleVisibility,
}: MarkerNotesControlProps) => {
  const { t } = useTranslation();

  if (count === 0) return null;

  const VisibilityIcon = areNotesVisible ? Eye : EyeOff;

  return (
    <Button
      variant="outline"
      size="sm"
      className="shrink-0"
      onClick={onToggleVisibility}
      aria-pressed={areNotesVisible}
      title={t(
        areNotesVisible
          ? "smartSurveyor.elementDetails.note.hideNotes"
          : "smartSurveyor.elementDetails.note.showNotes",
      )}
      startAdornment={<StickyNote className="w-3.5 h-3.5" />}
      endAdornment={
        <VisibilityIcon
          className={clsx(
            "w-3.5 h-3.5",
            areNotesVisible ? "text-blue-600" : "text-gray-400",
          )}
        />
      }
    >
      {t("smartSurveyor.elementDetails.note.notesButton")}
      <span className="px-1.5 rounded-full bg-gray-100 text-gray-700">
        {count}
      </span>
    </Button>
  );
};
